import { AnalyticsConfig } from '@growdash/analytics';
import { getEnv } from '@/lib/utils';

export const analyticsConfig: AnalyticsConfig = {
  googleTagManager: {
    gtmId: getEnv('VITE_GOOGLE_TAG_KEY'),
    enabled: !!getEnv('VITE_GOOGLE_TAG_KEY')
  },
  mixpanel: {
    token: getEnv('VITE_MIXPANEL_KEY'),
    enabled: !!getEnv('VITE_MIXPANEL_KEY'),
    sessionReplayPercent: 10
  },
  hubspot: {
    hubspotId: getEnv('VITE_HUBSPOT_ID'),
    enabled: !!getEnv('VITE_HUBSPOT_ID')
  }
};
